import { render, staticRenderFns } from "./storeSpreadPage.vue?vue&type=template&id=1e63debc&scoped=true"
var script = {}
import style0 from "./storeSpreadPage.vue?vue&type=style&index=0&id=1e63debc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63debc",
  null
  
)

export default component.exports